import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getDashboardStats() {
  const response = await axiosClient.get("/admin/dashboard");
  return response.data;
}

export async function getUsers(params) {
  const response = await axiosClient.get(`/admin/users${toQueryString(params)}`);
  return response.data;
}

export async function getUserDetail(id) {
  const response = await axiosClient.get(`/admin/users/${id}`);
  return response.data;
}

export async function setUserActiveStatus(id, isActive) {
  const response = await axiosClient.put(`/admin/users/${id}/status`, { isActive });
  return response.data;
}

export async function setDriverCompany(id, deliveryCompanyUserId) {
  const response = await axiosClient.put(`/admin/drivers/${id}/company`, { deliveryCompanyUserId });
  return response.data;
}

export async function setDriverAvailability(id, isAvailable) {
  const response = await axiosClient.put(`/admin/drivers/${id}/availability`, { isAvailable });
  return response.data;
}

export async function setUserPassword(id, password) {
  const response = await axiosClient.put(`/admin/users/${id}/password`, { password });
  return response.data;
}

export async function createUser(payload) {
  const response = await axiosClient.post("/admin/users", payload);
  return response.data;
}

export async function getClients(params) {
  const response = await axiosClient.get(`/admin/clients${toQueryString(params)}`);
  return response.data;
}

export async function getClientWarnings(id) {
  const response = await axiosClient.get(`/admin/clients/${id}/warnings`);
  return response.data;
}

export async function addClientWarning(id, payload) {
  const response = await axiosClient.post(`/admin/clients/${id}/warnings`, payload);
  return response.data;
}

export async function deleteClientWarning(warningId) {
  await axiosClient.delete(`/admin/clients/warnings/${warningId}`);
}

export async function setClientBanStatus(id, isBanned, reason, durationDays) {
  const response = await axiosClient.put(`/admin/clients/${id}/ban`, { isBanned, reason, durationDays });
  return response.data;
}

export async function setClientWholesaleStatus(id, isWholesaleClient) {
  const response = await axiosClient.put(`/admin/clients/${id}/wholesale`, { isWholesaleClient });
  return response.data;
}

export async function getStores(params) {
  const response = await axiosClient.get(`/admin/stores${toQueryString(params)}`);
  return response.data;
}

export async function getStoreDetail(id) {
  const response = await axiosClient.get(`/admin/stores/${id}`);
  return response.data;
}

export async function setStoreApproval(id, isApproved) {
  const response = await axiosClient.put(`/admin/stores/${id}/approval`, { isApproved });
  return response.data;
}

export async function setStoreActiveStatus(id, isActive) {
  const response = await axiosClient.put(`/admin/stores/${id}/status`, { isActive });
  return response.data;
}

export async function setStoreIsPrime(id, isPrime) {
  const response = await axiosClient.put(`/admin/stores/${id}/prime`, { isPrime });
  return response.data;
}

export async function setStoreComingSoon(id, isComingSoon) {
  const response = await axiosClient.put(`/admin/stores/${id}/coming-soon`, { isComingSoon });
  return response.data;
}

export async function setStoreCommissionOverride(id, commissionOverridePercent) {
  const response = await axiosClient.put(`/admin/stores/${id}/commission-override`, { commissionOverridePercent });
  return response.data;
}

export async function setStorePrimeDeliveryCompany(id, deliveryCompanyUserId) {
  const response = await axiosClient.put(`/admin/stores/${id}/prime-delivery-company`, { deliveryCompanyUserId });
  return response.data;
}

export async function setStoreType(id, type) {
  const response = await axiosClient.put(`/admin/stores/${id}/type`, { type });
  return response.data;
}

export async function getOrders(params) {
  const response = await axiosClient.get(`/admin/orders${toQueryString(params)}`);
  return response.data;
}

export async function getOrderDetail(id) {
  const response = await axiosClient.get(`/admin/orders/${id}`);
  return response.data;
}

export async function updateOrderStatus(id, status, note) {
  const response = await axiosClient.put(`/admin/orders/${id}/status`, { status, note });
  return response.data;
}

export async function deleteOrder(id) {
  await axiosClient.delete(`/admin/orders/${id}`);
}

export async function bulkDeleteOrders(orderIds) {
  const response = await axiosClient.post(`/admin/orders/bulk-delete`, { orderIds });
  return response.data;
}

export async function getDeliveries(params) {
  const response = await axiosClient.get(`/admin/deliveries${toQueryString(params)}`);
  return response.data;
}

export async function getDrivers(params) {
  const response = await axiosClient.get(`/admin/drivers${toQueryString(params)}`);
  return response.data;
}

export async function getDeliveryCompanies() {
  const response = await axiosClient.get("/admin/delivery-companies");
  return response.data;
}

export async function getDeliveryCompanyDetail(id) {
  const response = await axiosClient.get(`/admin/delivery-companies/${id}`);
  return response.data;
}

export async function updateDeliveryCompanyAccess(id, hasFullAccess, pairs, districts) {
  const response = await axiosClient.put(`/admin/delivery-companies/${id}/access`, {
    hasFullAccess,
    pairs,
    districts,
  });
  return response.data;
}

export async function getDistricts() {
  const response = await axiosClient.get("/admin/districts");
  return response.data;
}

export async function setDeliveryCompanyCommissionOverride(id, commissionOverridePercent) {
  const response = await axiosClient.put(`/admin/delivery-companies/${id}/commission-override`, {
    commissionOverridePercent,
  });
  return response.data;
}

export async function getCompanyStorePayouts(id) {
  const response = await axiosClient.get(`/admin/delivery-companies/${id}/store-fees`);
  return response.data;
}

export async function getCompanyStorePayoutHistory(id) {
  const response = await axiosClient.get(`/admin/delivery-companies/${id}/store-fees/history`);
  return response.data;
}

export async function getCategories(params) {
  const response = await axiosClient.get(`/categories${toQueryString(params)}`);
  return response.data;
}

export async function createCategory(payload) {
  const response = await axiosClient.post("/categories", payload);
  return response.data;
}

export async function updateCategory(id, payload) {
  const response = await axiosClient.put(`/categories/${id}`, payload);
  return response.data;
}

export async function deleteCategory(id) {
  await axiosClient.delete(`/categories/${id}`);
}

export async function getPartnerRequests(params) {
  const response = await axiosClient.get(`/partner-requests${toQueryString(params)}`);
  return response.data;
}

export async function setPartnerRequestStatus(id, status, adminNote) {
  const response = await axiosClient.put(`/partner-requests/${id}/status`, { status, adminNote });
  return response.data;
}

export async function deletePartnerRequest(id) {
  await axiosClient.delete(`/partner-requests/${id}`);
}

export async function getDeliveryPricing(params) {
  const response = await axiosClient.get(`/deliverypricing${toQueryString(params)}`);
  return response.data;
}

export async function updateDeliveryPricing(id, price) {
  const response = await axiosClient.put(`/deliverypricing/${id}`, { price });
  return response.data;
}

export async function getStoreOptions() {
  const response = await axiosClient.get("/Stores");
  return response.data;
}

export async function getAdvertisements() {
  const response = await axiosClient.get("/advertisements");
  return response.data;
}

export async function createAdvertisement(payload) {
  const response = await axiosClient.post("/advertisements", payload);
  return response.data;
}

export async function updateAdvertisement(id, payload) {
  const response = await axiosClient.put(`/advertisements/${id}`, payload);
  return response.data;
}

export async function uploadAdvertisementImage(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/advertisements/${id}/image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function uploadAdvertisementVideo(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/advertisements/${id}/video`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function deleteAdvertisement(id) {
  await axiosClient.delete(`/advertisements/${id}`);
}

export async function getCities(params) {
  const response = await axiosClient.get(`/Cities${toQueryString(params)}`);
  return response.data;
}

export async function createCity(payload) {
  const response = await axiosClient.post("/Cities", payload);
  return response.data;
}

export async function updateCity(id, payload) {
  const response = await axiosClient.put(`/Cities/${id}`, payload);
  return response.data;
}
